import { WindowHelper } from '../WindowHelper';

export default class SimpleAccordion {
    attachEvent() {
        this.triggerNode.addEventListener(this.event, () => {
            this.triggerNode.classList.toggle('is-active');
            this.contentNode.classList.toggle('is-active');
        });
    }
    init(nodeQS) {
        console.log('simple accordion init called');
        this.triggerNode = document.querySelector(nodeQS);
        this.contentNode = document.querySelector(`${nodeQS} + div`);
        this.event = WindowHelper.isTouchDevice() ? 'touchend' : 'click';
        this.attachEvent();
    }
    constructor(nodeQS) {
        if (WindowHelper.isElementThere(nodeQS)) this.init(nodeQS);
    }
}
